import {gql} from '@apollo/client';

export default gql`
  mutation mergeProduct($input: MergeProductInput!) {
    authed {
      success
    }
    mergeProduct(input: $input) {
      product {
        id
        name
        slug
        url
        description
        createdAt

        image {
          id
          width
          height
          src
          contentType
        }
      }
    }
  }
`;
